/**
 * Recharge Subscription Transition Handler
 * Handles smooth transitions for subscription sub-container when selected
 */
(function () {
  'use strict';

  /**
   * Apply styles to rc-benefits list items in shadow DOM
   * @param {ShadowRoot|HTMLElement} root - Shadow root or element to search within
   */
  const applyBenefitsListStyles = (root) => {
    const rcBenefits = root.querySelector?.('rc-benefits');
    
    if (rcBenefits) {
      const benefitsShadowRoot = rcBenefits.shadowRoot;
      if (benefitsShadowRoot) {
        const existingStyle = benefitsShadowRoot.querySelector('#rc-benefits-custom-styles');
        if (!existingStyle) {
          const style = document.createElement('style');
          style.id = 'rc-benefits-custom-styles';
          style.textContent = `
            .rc-benefits__list ul > li {
              padding-bottom: 10px !important;
              position: relative !important;
            }
            .rc-benefits__list ul > li::before {
              content: '' !important;
              display: inline-flex !important;
              width: 17px !important;
              height: 17px !important;
              border-radius: 50% !important;
              background-color: #660C3A !important;
              background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='white' d='M10 3L4.5 8.5L2 6l1.5-1.5L4.5 6l4-4L10 3z'/%3E%3C/svg%3E") !important;
              background-size: 12px 12px !important;
              background-repeat: no-repeat !important;
              background-position: center !important;
              margin-right: 8px !important;
              vertical-align: middle !important;
              -webkit-mask-image: none !important;
              mask-image: none !important;
              top: 0 !important;
            }
          `;
          benefitsShadowRoot.appendChild(style);
        }
      }
    }
  };

  /**
   * Apply styles to sub-container when it's added
   * @param {HTMLElement} subContainer - The sub-container element
   */
  const applySubContainerStyles = (subContainer) => {
    // Add visible class for CSS transition
    subContainer.classList.add('rc-sub-container--visible');

    // Set widget attribute for ::part() CSS selector
    const widget =
      subContainer.closest('recharge-subscription-widget') ||
      document.querySelector('recharge-subscription-widget');
    
    if (widget) {
      widget.setAttribute('data-subscription-selected', 'true');
      
      // Apply styles to benefits list items
      if (widget.shadowRoot) {
        applyBenefitsListStyles(widget.shadowRoot);
      }
    }
  };

  /**
   * Setup observer to watch for subscription sub-container being added
   */
  const setupSubscriptionObserver = () => {
    // Find the form wrapper which contains the Recharge widget
    const formWrapper = document.querySelector('[data-form-wrapper]');
    if (!formWrapper) return;

    const widget = document.querySelector('recharge-subscription-widget');

    // Watch for sub-container being added to DOM
    const subtreeObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) {
            // Check if this is the sub-container being added
            if (
              node.classList?.contains('rc-purchase-option__sub-container') ||
              node.querySelector?.('.rc-purchase-option__sub-container')
            ) {
              const subContainer = node.classList?.contains('rc-purchase-option__sub-container')
                ? node
                : node.querySelector('.rc-purchase-option__sub-container');
              
              if (subContainer) {
                // Apply styles when element is added
                setTimeout(() => {
                  applySubContainerStyles(subContainer);
                }, 10);
              }
            }
          }
        });
      });
    });

    // Start observing
    subtreeObserver.observe(formWrapper, {
      childList: true,
      subtree: true,
    });

    // Also observe the widget's shadow root if it exists
    if (widget?.shadowRoot) {
      const shadowObserver = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === Node.ELEMENT_NODE) {
              if (node.classList?.contains('rc-purchase-option__sub-container')) {
                setTimeout(() => {
                  applySubContainerStyles(node);
                  widget.setAttribute('data-subscription-selected', 'true');
                }, 10);
              }
              if (node.tagName === 'RC-BENEFITS' || node.querySelector?.('rc-benefits')) {
                setTimeout(() => {
                  applyBenefitsListStyles(widget.shadowRoot);
                }, 10);
              }
            }
          });
          
          mutation.removedNodes.forEach((node) => {
            if (
              node.nodeType === Node.ELEMENT_NODE &&
              node.classList?.contains('rc-purchase-option__sub-container')
            ) {
              widget.removeAttribute('data-subscription-selected');
            }
          });
        });
      });
      
      shadowObserver.observe(widget.shadowRoot, {
        childList: true,
        subtree: true,
      });
      
      setTimeout(() => {
        applyBenefitsListStyles(widget.shadowRoot);
      }, 100);
    }
  };

  // Initialize on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupSubscriptionObserver);
  } else {
    setupSubscriptionObserver();
  }
})();
